// 多言語化の中心設定。言語コード・URLプレフィックスの相互変換をここに集約する。

export const SUPPORTED_LANGS = ['ja', 'en', 'zh-CN', 'zh-TW'];
export const DEFAULT_LANG = 'ja';

// URLでは地域コード（zh-CN / zh-TW）、<html lang>とhreflangでは文字体系コードを使う。
// 文字体系コードの方がフォント選択と検索エンジンの解釈が正確になる。
export const HTML_LANG = {
  ja: 'ja',
  en: 'en',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant',
};

// 言語切替UIのラベル。国旗は使わない（繁体字は台湾・香港・マカオ、
// 簡体字は中国本土・シンガポール・マレーシアで使われるため誤解を招く）。
export const LANG_LABELS = {
  ja: 'JA',
  en: 'EN',
  'zh-CN': '简体',
  'zh-TW': '繁體',
};

// ドロップダウンなど、幅に余裕がある場所で使う言語名。
export const LANG_NAMES = {
  ja: '日本語',
  en: 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
};

export const OG_LOCALE = {
  ja: 'ja_JP',
  en: 'en_US',
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW',
};

export const SITE_ORIGIN = 'https://jtc-net.co.jp';

/** 言語のURLプレフィックス。日本語は空文字（プレフィックスなし）。 */
export const pathPrefix = (lang) => (lang === DEFAULT_LANG ? '' : `/${lang}`);

/**
 * パスから言語プレフィックスを剥がす。
 * `/en/about` → `{ lang: 'en', rest: '/about' }`
 * `/energy`   → `{ lang: 'ja', rest: '/energy' }`（前方一致で誤判定しない）
 */
export function stripLangPrefix(pathname) {
  for (const lang of SUPPORTED_LANGS) {
    if (lang === DEFAULT_LANG) continue;
    const prefix = `/${lang}`;
    if (pathname === prefix || pathname === `${prefix}/`) {
      return { lang, rest: '/' };
    }
    if (pathname.startsWith(`${prefix}/`)) {
      return { lang, rest: pathname.slice(prefix.length) };
    }
  }
  return { lang: DEFAULT_LANG, rest: pathname || '/' };
}

/**
 * 言語プレフィックスなしのパスに、指定言語のプレフィックスを付ける。
 * `localePath('/about', 'en')` → `/en/about`
 * `localePath('/', 'en')`      → `/en`（末尾スラッシュは付けない）
 */
export function localePath(path, lang) {
  const clean = path.startsWith('/') ? path : `/${path}`;
  const prefix = pathPrefix(lang);
  if (clean === '/') return prefix || '/';
  return `${prefix}${clean}`;
}

/** 現在のURLパスから言語を判定する（Analyticsなど、React外から使う用）。 */
export const getLangFromPath = (pathname) =>
  stripLangPrefix(pathname ?? window.location.pathname).lang;
